module.exports = __webpack_public_path__ + "static/media/ploni-bold-aaa.77893908.woff";